import React, { useCallback, useState } from "react";

import { AppLeftBarItem as IAppLeftBarItem } from "../AppLeftBarMenuItems";
import { MenuItem, useIsOverflowItemVisible, Tooltip } from "@fluentui/react-components";
import { observer } from "mobx-react";
import { useNavigate } from "react-router";
import { useOverflowMenuItemStyles } from "./OverflowMenuItem.styles";
import { M365PulseText } from "Shared/Components";

const OverflowMenuItemBase = ({ app, onClick }: { app: IAppLeftBarItem; onClick?: () => void }) => {
    const [isMouseOver, setIsMouseOver] = useState(false);
    const classnames = useOverflowMenuItemStyles({ isMouseOver: isMouseOver });
    const isVisible = useIsOverflowItemVisible(app.displayName);
    const navigate = useNavigate();

    const onMenuItemClick = useCallback(() => {
        if (onClick) {
            onClick();
        }
        if (app.routeName) {
            navigate(app.routeName);
        }
    }, [app.routeName, navigate, onClick]);

    const onMouseEnter = useCallback(() => {
        setIsMouseOver(true);
    }, []);

    const onMouseLeave = useCallback(() => {
        setIsMouseOver(false);
    }, []);

    return (
        !isVisible && (
            <Tooltip content={app.displayName} relationship="label">
                <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                    <MenuItem
                        key={app.displayName}
                        onClick={onMenuItemClick}
                        className={classnames.root}
                        aria-label={app.description ? `${app.displayName}, ${app.description}` : app.displayName}
                    >
                        {app.filledIcon && <app.filledIcon className={classnames.icon} />}
                        <div className={classnames.name}>
                            <M365PulseText align="center">{app.displayName}</M365PulseText>
                        </div>
                    </MenuItem>
                </div>
            </Tooltip>
        )
    );
};

export const OverflowMenuItem = observer(OverflowMenuItemBase);
